import { createContext, useContext } from 'react';

/**
 * DOM node that Base-UI overlays (menus, dialogs, popovers, toasts) inside the
 * scheduler should portal into. `null` → default (document.body).
 *
 * While the scheduler is in native fullscreen, this is set to the fullscreen
 * element so overlays stay visible — the Fullscreen API paints ONLY the
 * fullscreen element's own subtree, so a body portal would be invisible.
 */
const SchedulerPortalContainerContext = createContext<HTMLElement | null>(null);

export const SchedulerPortalContainerProvider = SchedulerPortalContainerContext.Provider;

/** The portal container, or `null` to use the default `document.body` portal. */
export function useSchedulerPortalContainer(): HTMLElement | null {
  return useContext(SchedulerPortalContainerContext);
}
